import React from "react";
import { LegalPage } from "./LegalPage";
import { IMPRESSUM } from "../data/legalContent";

export default function Impressum() {
  return <LegalPage data={IMPRESSUM} path="/impressum" testId="impressum-page" />;
}
